export default "__VITE_ASSET__37cfede7__"